import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux';

import HasFeature from "src/utils/has-feature";
import HasRole from "src/utils/has-role";

import PlaybooksList from "./pages/list";
import PlaybookDetail from "./pages/detail";
import PlaybookEditor from "./pages/editor";
import PlaybooksContext from "./pages/context";

import GroupContainer from "src/components/group-container";
import GroupMenu from "src/components/group-menu";

import { BookOpenIcon } from "@heroicons/react/24/outline";
import RedirectRenderer from "src/components/redirect-renderer";

export const getRoutes = () => [
  { name: 'Playbooks Overview', description: 'Automate workflows and processes with custom playbooks', path: '/playbooks/summary', check: true },
  { name: 'Shared Context', description: 'Manage context provided to playbooks', path: '/playbooks/context', check: true },
];

const Layout = ({ children }) => {
  const items = [
    { name: 'Playbooks Overview', description: "Automate workflows and processes with custom playbooks", icon: BookOpenIcon, path: '/playbooks/summary', check: true },
    { name: 'Shared Context', description: 'Manage context provided to playbooks', path: '/playbooks/context', check: true },
    { name: 'Playbook', parent: 'Playbooks', description: 'View, edit, and manage a playbook', visible: false, path: '/playbooks/playbook/:id', check: true },
  ];
  
  return (
    <div id="content">
      <GroupMenu items={items} title="Playbooks" />
      <GroupContainer>
        {children}
      </GroupContainer>
    </div>
  )
};

const redirects = [
  { from: '/playbooks', to: '/playbooks/summary' },
];

const Playbooks = () => {
  const { organisation: { features }, account: { account } } = useSelector((state) => state);

  if (account?.id) {
    const hasAccess = HasRole(account, ['developers:manage:keys', 'developers:manage:webhooks'], true) && HasFeature(features, ['developers', 'playbooks']);

    if (!hasAccess) {
      return <React.Fragment />;
    }

    return (
      <React.Fragment>
        { RedirectRenderer({ redirects }) }
        <Route exact path="/playbooks/summary" component={() => <Layout><PlaybooksList /></Layout>} />
        <Route exact path="/playbooks/context" component={() => <Layout><PlaybooksContext /></Layout>} />
        <Route exact path="/playbooks/playbook/:id/edit" component={() => <PlaybookEditor />} />
        <Route exact path="/playbooks/playbook/:id" component={() => <Layout><PlaybookDetail /></Layout>} />
      </React.Fragment>
    );
  }

  return <React.Fragment />;
};

export default Playbooks;
